import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CurrencyStatus, CurrencyItem } from '../../types';
import { currenciesApi } from '../services';

export interface FormValues {
  status: CurrencyStatus;
  numericCode: string;
  characterCode: string;
  description: string;
  units: string;
  useReverseRateValue: boolean;
}

export interface CurrencyFormState {
  isLoading: boolean;
  requestInProgress: boolean;
  currencyId?: string;
  formValues?: CurrencyItem;
  submitSuccess?: boolean;
}

const initialState: CurrencyFormState = {
  isLoading: false,
  requestInProgress: false,
};

export const currencyFormSlice = createSlice({
  name: 'currencyForm',
  initialState,
  reducers: {
    onSubmit: (state, action: PayloadAction<CurrencyItem>) => {
      state.formValues = action.payload;
      state.submitSuccess = false;
    },
    clearCurrencyFormState: (state) => {
      state.isLoading = false;
      state.currencyId = undefined;
      state.requestInProgress = false;
      state.formValues = undefined;
      state.submitSuccess = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      currenciesApi.endpoints.getConfigurationCurrency.matchFulfilled,
      (state, action: PayloadAction<{ data: CurrencyItem }>) => {
        state.formValues = action.payload.data;
      },
    );
    builder.addMatcher(
      currenciesApi.endpoints.createCurrency.matchFulfilled,
      (state) => {
        state.submitSuccess = true;
      },
    );
  },
});

export const { clearCurrencyFormState, onSubmit } = currencyFormSlice.actions;

export default currencyFormSlice.reducer;
